import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isVpaasMeeting } from '../../../../jaas/functions';
import { translate } from '../../../i18n/functions';
/**
 * The CSS style of the element with CSS class {@code rightwatermark}.
 *
 * @private
 */
const _RIGHT_WATERMARK_STYLE = {
    backgroundImage: 'url(images/rightwatermark.png)'
};
/**
 * A Web Component which renders watermarks such as Jits, brand, powered by,
 * etc.
 */
class Watermarks extends Component {
    /**
     * Initializes a new Watermarks instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        const showBrandWatermark = interfaceConfig.SHOW_BRAND_WATERMARK;
        this.state = {
            brandWatermarkLink: showBrandWatermark ? interfaceConfig.BRAND_WATERMARK_LINK : '',
            showBrandWatermark,
            showPoweredBy: interfaceConfig.SHOW_POWERED_BY
        };
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        return (React.createElement("div", null,
            this._renderJitsiWatermark(),
            this._renderBrandWatermark(),
            this._renderPoweredBy()));
    }
    /**
     * Injecte le CSS pour forcer la taille du logo après le montage du composant.
     */
    componentDidMount() {
        const style = document.createElement('style');
        style.textContent = `
            .leftwatermark, .watermark.leftwatermark {
                max-width: 180px !important;
                max-height: 90px !important;
                width: 180px !important;
                height: 90px !important;
                min-width: 180px !important;
                min-height: 90px !important;
                font-size: 18px !important;
            }
            .welcome .welcome-watermark .watermark.leftwatermark {
                width: 100px !important;
                height: 50px !important;
                max-width: 100px !important;
                max-height: 50px !important;
            }
            .redirectPageMessage .leftwatermark,
            .redirectPageMessage .watermark.leftwatermark,
            .welcome .leftwatermark,
            .welcome .watermark.leftwatermark {
                display: none !important;
                visibility: hidden !important;
                opacity: 0 !important;
            }
            @media only screen and (max-width: 500px), only screen and (max-height: 400px) {
                .leftwatermark, .watermark.leftwatermark {
                    width: 80px !important;
                    height: 40px !important;
                    max-width: 80px !important;
                    max-height: 40px !important;
                    min-width: 80px !important;
                    min-height: 40px !important;
                    left: 12px !important;
                    top: 12px !important;
                }
            }
        `;
        document.head.appendChild(style);
    }
    /**
     * Renders a brand watermark if it is enabled.
     *
     * @private
     * @returns {ReactElement|null} Watermark element or null.
     */
    _renderBrandWatermark() {
        let reactElement = null;
        if (this.state.showBrandWatermark) {
            reactElement = (React.createElement("div", { className: 'watermark rightwatermark', style: _RIGHT_WATERMARK_STYLE }));
            const { brandWatermarkLink } = this.state;
            if (brandWatermarkLink) {
                reactElement = (React.createElement("a", { href: brandWatermarkLink, target: '_new' }, reactElement));
            }
        }
        return reactElement;
    }
    /**
     * Renders a Jitsi watermark if it is enabled.
     *
     * @private
     * @returns {ReactElement|null}
     */
    _renderJitsiWatermark() {
        const { _logoLink, _logoUrl, _showJitsiWatermark } = this.props;
        const { noMargins, t } = this.props;
        const className = `watermark leftwatermark ${noMargins ? 'no-margin' : ''}`;
        let reactElement = null;
        if (_showJitsiWatermark) {
            let finalLogoUrl = _logoUrl;
            try {
                const companyLogo = sessionStorage.getItem('VISIO_COMPANY_LOGO');
                if (companyLogo) {
                    // Logo de l'entreprise reçu via postMessage
                    finalLogoUrl = companyLogo;
                }
                else {
                    // Logo Le-Qube par défaut
                    finalLogoUrl = 'images/logo_Le_Qube_blanc.png';
                }
            }
            catch (e) {
                // Fallback vers logo Le-Qube si sessionStorage erreur
                finalLogoUrl = 'images/logo_Le_Qube_blanc.png';
            }
            const style = {
                backgroundImage: `url(${finalLogoUrl})`,
                position: _logoLink ? 'static' : 'absolute',
                maxWidth: '200px !important',
                maxHeight: '100px !important',
                width: '200px !important',
                height: '100px !important',
                left: '32px',
                top: '32px'
            };
            reactElement = (React.createElement("div", { className: className, style: style }));
            if (_logoLink) {
                reactElement = (React.createElement("a", { "aria-label": t('jitsiHome', { logo: interfaceConfig.APP_NAME }), className: className, href: _logoLink, target: '_new' }, reactElement));
            }
        }
        return reactElement;
    }
    /**
     * Renders a powered by block if it is enabled.
     *
     * @private
     * @returns {ReactElement|null}
     */
    _renderPoweredBy() {
        if (this.state.showPoweredBy) {
            const { t } = this.props;
            return (React.createElement("a", { className: 'poweredby', href: '', target: '_new' },
                React.createElement("span", null,
                    t('poweredby'),
                    " jitsi.org")));
        }
        return null;
    }
}
/**
 * Maps parts of Redux store to component prop types.
 *
 * @param {Object} state - Snapshot of Redux store.
 * @param {Object} ownProps - Component's own props.
 * @returns {IProps}
 */
function _mapStateToProps(state, ownProps) {
    if (new URLSearchParams(window.location.search).get('config.liveCoachingMode') === 'viewer') {
        return { _logoLink: '', _logoUrl: undefined, _showJitsiWatermark: false };
    }
    const { customizationReady, customizationFailed, defaultBranding, useDynamicBrandingData, logoClickUrl, logoImageUrl } = state['features/dynamic-branding'];
    const isValidRoom = state['features/base/conference'].room;
    const { defaultLogoUrl } = state['features/base/config'];
    const { JITSI_WATERMARK_LINK, SHOW_JITSI_WATERMARK } = interfaceConfig;
    let _showJitsiWatermark = (customizationReady && !customizationFailed
        && SHOW_JITSI_WATERMARK)
        || !isValidRoom;
    let _logoUrl = logoImageUrl;
    let _logoLink = '';
    if (useDynamicBrandingData) {
        if (isVpaasMeeting(state)) {
            // don't show logo if request fails or no logo set for vpaas meetings
            _showJitsiWatermark = !customizationFailed && Boolean(logoImageUrl);
        }
        else if (defaultBranding) {
            _logoUrl = defaultLogoUrl;
            _logoLink = '';
        }
    }
    else {
        // When there is no custom branding data use defaults
        _logoUrl = ownProps.defaultJitsiLogoURL || defaultLogoUrl;
        _logoLink = '';
    }
    return {
        _logoLink,
        _logoUrl,
        _showJitsiWatermark
    };
}
export default translate(connect(_mapStateToProps)(Watermarks));
